import isNil from 'lodash/isNil';

import {formatMaxHistoryDays} from 'common/report/util';
import {getCurrentDateAsOf, getCurrentMoment} from 'common/util/date';

export function getDateLimitedTooltipText({maxHistoryDays, showUpsell, beforeEpoch}) {
  if (showUpsell) {
    return `Upgrade your plan to query beyond ${formatMaxHistoryDays(maxHistoryDays)}`;
  } else if (beforeEpoch) {
    return `Cannot query before January 1st, 1970`;
  } else {
    return `Cannot query beyond ${formatMaxHistoryDays(maxHistoryDays)}`;
  }
}

export function getMinDateStr({maxHistoryDays}) {
  if (isNil(maxHistoryDays)) {
    return null;
  } else {
    return getCurrentMoment().subtract(maxHistoryDays, `days`).format(`YYYY-MM-DD`);
  }
}

export function daysAgoFormatted(numDaysAgo, projectAsOfDate) {
  const today = getCurrentDateAsOf(projectAsOfDate);
  const dateDaysAgo = new Date(today.setDate(today.getDate() - numDaysAgo));
  // necessary for moment conversions, safari doesn't accept a format like 2020-1-1
  const dayString = dateDaysAgo.getDate().toString().padStart(2, `0`); // 01, 02 ... 30, 31
  const monthString = (dateDaysAgo.getMonth() + 1).toString().padStart(2, `0`); // 01, 02, ... 11, 12
  return `${dateDaysAgo.getFullYear()}-${monthString}-${dayString}`;
}
